<template>
    <div class="tw-flex tw-items-center tw-justify-end tw-space-x-8 tw-text-gray-500">
        <span>{{ $t("feedback.analytics.labels.sortBy") }}:</span>
        <button
            v-for="type in [
                ...(sort.targetBadge ? ['badge'] : []),
                'sent',
                'received',
                'requested',
            ]"
            :key="type"
            type="button"
            class="tw-select-none tw-font-bold tw-border-0 tw-text-sm tw-py-2 tw-px-4 tw-rounded-md tw-cursor-pointer min-width-80px tw-flex tw-items-baseline tw-align-baseline tw-content-center tw-justify-center"
            :class="{
                'tw-bg-gray-100 hover:tw-bg-gray-200 focus:tw-bg-gray-200 tw-text-gray-500':
                    sort.path !== type,
                'tw-bg-indigo-500 hover:tw-bg-indigo-600 focus:tw-bg-indigo-600 tw-text-indigo-50':
                    sort.path === type,
                'tw-cursor-wait': loading,
            }"
            @click="onClick(type)"
            @keypress="onClick(type)"
        >
            <i
                v-if="sort.path === type"
                class="tw-mr-2 fa"
                :class="{
                    'fa-sort-numeric-down': sort.direction === 'desc',
                    'fa-sort-numeric-up': sort.direction === 'asc',
                }"
            />
            {{
                type === "badge" && badges[sort.targetBadge]
                    ? badges[sort.targetBadge].name
                    : $t(`feedback.analytics.userlist.${type}`)
            }}
        </button>
    </div>
</template>

<script>
export default {
    props: {
        badges: {
            type: Object,
            default: () => ({}),
        },
        sort: {
            type: Object,
            default: () => ({}),
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        onClick(type) {
            if (!type || this.loading) return;

            this.$emit("sortChange", type);
        },
    },
};
</script>

<style scoped>
.min-width-80px {
    min-width: 80px;
}
</style>
